<template>
  <div class="notice-page">
    <div class="notice-info">
      <div class="notice-info-box">
        <div class="title">
          <div>{{ noticeDetail.title }}</div>
          <div class="time">{{ noticeDetail.createTime }}</div>
        </div>
        <div class="rmks" v-html="noticeDetail.content"></div>
      </div>
    </div>
    <div class="back-btn" @click="$router.back()">返回</div>
  </div>
</template>

<script>
import { getNoticeDetail } from '@/api/common'

export default {
  name: 'noticeDetail',
  data() {
    return {
      noticeId: '',
      noticeDetail: {},
    }
  },
  methods: {
    getDetail() {
      getNoticeDetail({
        noticeId: this.noticeId,
      }).then((res) => {
        this.noticeDetail = res.data
      })
      // this.noticeDetail = {
      //   id: '1',
      //   title: '新课上线通知',
      //   time: '2023-12-12 20:00:00',
      //   rmk: '各位学员请注意了，2023年12月3日，PLAMS 系统将有新课上线。请各位学员做好学习准备。',
      // }
    },
  },
  created() {},
  mounted() {
    this.noticeId = this.$route.query.id
    this.getDetail()
  },
}
</script>

<style lang="scss">
.notice-page {
  width: 100%;
  padding: 20px 0;
  background: url('../../assets/img/notice-bg.png') top center no-repeat;
  background-size: contain;
  .notice-info {
    margin: 0 20px;
    &-box {
      max-height: calc(100vh - 120px);
      padding-bottom: 10px;
      overflow-y: scroll;
      font-size: 12px;
      padding: 10px 16px;
      background-color: #fff;
      margin-bottom: 14px;
      border-radius: 8px;
      & > div {
        margin-bottom: 6px;
      }
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #000;
        font-size: 15px;
        font-weight: 500;
        margin-bottom: 12px;
        padding-bottom: 10px;
        border-bottom: 0.5px solid #dad9de;
        .time {
          color: #b5b4ba;
          font-family: 'Porsche Next';
          font-size: 10px;
          font-weight: 400;
        }
      }
      .time {
        font-size: 10px;
        font-weight: 400;
        color: #b5b4ba;
      }
      .rmks {
        font-size: 14px;
        color: #737278;
        min-height: 300px;
        padding-bottom: 10px;
        word-break: break-all;
        p {
          margin: 0;
        }
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
